if ( typeof window !== "undefined" ) {
    type WindowWithOriginalOpen = Window & {
        __originalOpen?: Window["open"];
    };
    const patchedWindow = window as WindowWithOriginalOpen;

    // 重写 window.open，统一兼容 Android App WebView 打开外链的方式。
    //
    // 开发环境 Fast Refresh/HMR 可能让当前模块重复执行。如果每次都把当前
    // window.open 当成“原始方法”保存，补丁会被一层层包裹，回退逻辑也会变得
    // 难以追踪。因此这里仅在第一次执行时保存浏览器原始 window.open。
    patchedWindow.__originalOpen ||= window.open.bind( window );

    window.open = ( url?: string | URL, target?: string, features?: string ): WindowProxy | null => {
        const originalOpen = patchedWindow.__originalOpen!;

        // 保持 window.open() 无参数调用的原生行为。
        if ( url === undefined ) return originalOpen();

        const href = url.toString();

        // App 内优先交给 AndroidShell.openURL 处理，由原生侧决定用系统浏览器、
        // App 内页面或其他方式打开链接。原生方法没有返回 WindowProxy，因此这里
        // 与浏览器拦截弹窗失败的语义保持一致，返回 null。
        //
        // 如果当前不是 App 环境、App 未注入 openURL，或原生调用抛错，则回退到
        // 浏览器默认 window.open，保留 target/features 参数的原有行为。
        if ( window.AndroidShell && typeof window.AndroidShell.openURL === "function" ) {
            try {
                window.AndroidShell.openURL( href );
                return null;
            } catch {
                return originalOpen( href, target, features );
            }
        }

        return originalOpen( href, target, features );
    };
}
